import { IconHome, Icon as IconType } from "@tabler/icons-react";
import React from "react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { BackButton } from "@components/common/buttons/back-button";
import { Button } from "@components/ui/button";
import routes from "@features/routes";

export interface ErrorComponentProps {
  title?: string;
  subTitle?: string;
  description?: string | TrustedHTML;
  externalNodes?: React.ReactNode;
  homeLinkDisabled?: boolean;
  backLinkDisabled?: boolean;
  icon?: IconType;
}

export const ErrorComponent = ({
  title,
  subTitle,
  description,
  externalNodes,
  homeLinkDisabled,
  backLinkDisabled,
  icon: Icon,
}: ErrorComponentProps) => {
  const t = useTranslations("common.errors");

  return (
    <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
      {Icon && <Icon size={60} />}
      <h1 className="text-[7rem] leading-tight font-bold">{title}</h1>
      <span className="font-medium">{subTitle}</span>
      {description && (
        <p
          className="text-center text-muted-foreground"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      <div className="mt-6 flex items-center gap-4">
        {!backLinkDisabled && <BackButton />}
        {!homeLinkDisabled && (
          <Button asChild size="lg">
            <Link href={routes.application.pages.home.path()}>
              <IconHome className="opacity-50" />
              <span className="text-nowrap">{t("returnHome")}</span>
            </Link>
          </Button>
        )}
        {externalNodes}
      </div>
    </div>
  );
};
